<template>
  <router-view />
</template>

<style lang="scss">
#app {
  overflow: hidden;
}
</style>
